import { motion } from "framer-motion";

const ease = [0.2, 0.8, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedHeading = ({ text, as = "h1", className = "", delay = 0.15, stagger = 0.06 }) => {
  const Tag = motion[as];
  const words = text.split(" ");
  return (
    <Tag className={className} initial="hidden" animate="show" aria-label={text}>
      {words.map((w, i) => (
        <span key={i} aria-hidden="true" className="inline-block overflow-hidden align-bottom pb-[0.12em] -mb-[0.12em] mr-[0.24em]">
          <motion.span
            className="inline-block"
            variants={{ hidden: { y: "105%" }, show: { y: "0%" } }}
            transition={{ duration: 1.05, delay: delay + i * stagger, ease }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Rise = ({ children, delay = 0, className = "" }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay, ease }}>
    {children}
  </motion.div>
);
